import { format } from 'date-fns';
import TableCellStatus from '../../components/table-cell-status/table-cell-status.component';
import { displayCellValue, displayCellValueNumberToTwoDecimal } from '../../utils/column-values.util';
import { useMediaQuery } from 'react-responsive';

export const SALES_REPORT_BY_PAYMENT_INFO = {
    reportTitle: "Sales Reports",
    path: "/salesreports",
    subPath: "/salesbypayment",
    listPage: "/sales-reports",
    pagePath:"sales-orders",
    hasDateRange: true,
    hasChart: true,
    tableHasGrandTotal: true,
    hasPaymentStatusFilter: true,
    hasLocationFilter: true,
    hasSearch: true
}

export const SALES_REPORT_BY_PAYMENT_COLUMN_TEMPLATE = [
    {
        Header: "SO Number",
        accessor: "salesOrderNumber",
        Footer: 'Grand Total'
    },
    {
        Header: "Payment Status",
        accessor: "paymentStatus",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });
            const isRightAligned = true;

            if (!value) {
                return displayCellValue(value);
            }

            return (
                <div className={isMobileView && isRightAligned ?
                    'report-table__body__row__cell--right-aligned-mobile-cell' : ''}>
                    <TableCellStatus
                        value={value}
                    />
                </div>
            )
        }
    },
    {
        Header: "Customer",
        accessor: "customerName",
        Cell: ({ value }) => {
            return displayCellValue(value);
        }
    },

    {
        Header: "Total Sales (ETB)",
        accessor: "totalSales",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });

            if (isMobileView) {
                return `Total Sales: ${value ? displayCellValueNumberToTwoDecimal(value) : 0} ETB`;
            }


            return displayCellValueNumberToTwoDecimal(value);
        },
        Footer: 'grandTotalSales'
    },
    {
        Header: "Credit (ETB)",
        accessor: "credit",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });

            if (isMobileView) {
                return `Credit: ${value ? displayCellValueNumberToTwoDecimal(value) : 0} ETB`;
            }

            return displayCellValueNumberToTwoDecimal(value);
        },
        Footer: 'totalCredit'
    },
    {
        Header: "Due Date",
        accessor: "dueDate",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });

            if (isMobileView) {
                return null;
            }

            return displayCellValue(value);
        }
    },

]
